module.exports = __webpack_public_path__ + "img/QRcode-android.4b049084.png";